export interface IStatPillItem {
  label: string;
  value: number;
}

export interface StatPillsProps {
  stats: IStatPillItem[];
}

/** Renders a row of "label: value" pairs, e.g. summary counters beside a table. */
export function StatPills(props: StatPillsProps) {
  return (
    <>
      {props.stats.map(s => (
        <span key={s.label}>{s.label}: <strong>{s.value}</strong></span>
      ))}
    </>
  );
}

export default StatPills;
